export enum Operators {
	Retail = 'retail',
	Vectra = 'vectra',
	Multimedia = 'multimedia',
	Sgt = 'sgt',
	Elsat = 'elsat',
	Satfilm = 'satfilm'
}

export enum Systems {
	Retail = 'pureott',
	Vectra = 'vectra',
	Multimedia = 'MMPDTV',
	Sgt = 'SGT',
	Elsat = 'ofertaT4B1182',
	Satfilm = 'SATFILM'
}

export enum SubSystems {
	tvonline = 'tvonline'
}

export type System = {
	name: Systems;
	display_name: string;
};

export type SystemList = System[]